import { render, staticRenderFns } from "./WillCollectionBookingDialog.vue?vue&type=template&id=006f87a9&scoped=true"
import script from "./WillCollectionBookingDialog.vue?vue&type=script&lang=js"
export * from "./WillCollectionBookingDialog.vue?vue&type=script&lang=js"
import style0 from "./WillCollectionBookingDialog.vue?vue&type=style&index=0&id=006f87a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f87a9",
  null
  
)

export default component.exports